import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  to?: string; // ahora es opcional
}

interface BreadcrumbProps {
  pageName: string;
  routes?: BreadcrumbItem[];
}

const Breadcrumb = ({ pageName, routes = [] }: BreadcrumbProps) => {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-title-md2 font-semibold text-black dark:text-white">
        {pageName}
      </h2>

      {/* Breadcrumb visible solo en pantallas sm+ */}
      <nav className="hidden sm:block">
        <ol className="flex items-center gap-2">
          <li>
            <Link className="font-medium" to="/">
              Inicio /
            </Link>
          </li>

          {routes.map((route, index) => (
            <li key={index}>
              {route.to ? (
                <Link className="font-medium" to={route.to}>
                  {route.name} /
                </Link>
              ) : (
                <span className="font-medium">{route.name} /</span>
              )}
            </li>
          ))}

          <li className="font-medium text-primary">{pageName}</li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
